"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.constructor");

var _typeof2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/typeof"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _ExcelFileUtil = _interopRequireDefault(require("@/views/mixin/ExcelFileUtil"));

var _apolloClient = require("@/apollo/apolloClient");

var _companyMutation = require("@/apollo/mutations/company-mutation");

var _companyQuery = require("@/apollo/queries/company-query");

var _checkExt = require("../../utils/check-ext");

var _user = require("@/api/user");

var _firebase = _interopRequireDefault(require("firebase"));

var _validate = require("@/utils/validate");

var _moment = _interopRequireDefault(require("moment"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'ExcelUpload',
  mixins: [_ExcelFileUtil.default],
  props: {
    form: {
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;

    var validateRequireFileOption = function validateRequireFileOption(rule, value, callback) {
      if (_this.excelFile.length === 0 || _this.excelFile.length === undefined) {
        callback(new Error(rule.colname + 'を選択してください'));
      } else {
        callback();
      }
    };

    return {
      defaultRole: null,
      progress: 0,
      is_error: false,
      excelFile: [],
      uploadExcel: false,
      centerDialogVisible: false,
      found: 0,
      industries: [],
      users: [],
      user_affiliations: [],
      rules: {
        excelFile: [{
          required: true,
          validator: validateRequireFileOption,
          colname: '添付ファイル'
        }]
      },
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      introduceSample: {
        textProkuShibu: '',
        textShibuChiku: '',
        importSampleName: '',
        exampleBranchName: '',
        exampleName: '',
        exampleNumber: '',
        exampleFirst: '',
        exampleLast: '',
        number1: '',
        number2: ''
      }
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var importSample, industries, users, user_aff, defaultRole, listData, createDataByElTree;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createDataByElTree = function _ref(input) {
                return {
                  id: input.id,
                  label: input.name,
                  children: input.affiliations.map(function (subItem) {
                    return createDataByElTree(subItem);
                  })
                };
              };

              this.introduceSample.textProkuShibu = (0, _validate.switchTitle)().branchMassage;
              this.introduceSample.textShibuChiku = (0, _validate.switchTitle)().areaMessage;
              importSample = (0, _validate.switchTitle)().importSample.toString().split('/');
              this.introduceSample.importSampleName = importSample[1].toString();
              this.introduceSample.exampleName = (0, _validate.switchTitle)().exampleName;
              this.introduceSample.exampleNumber = (0, _validate.switchTitle)().exampleNumber;
              _context.t0 = (0, _validate.switchTitle)().branchName;
              _context.next = _context.t0 === '広島' ? 10 : _context.t0 === '大阪' ? 16 : 22;
              break;

            case 10:
              this.introduceSample.exampleBranchName = '広島中支部';
              this.introduceSample.exampleFirst = '中1地区会';
              this.introduceSample.exampleLast = '中1地区会役員会';
              this.introduceSample.number1 = '1077';
              this.introduceSample.number2 = '1064';
              return _context.abrupt("break", 23);

            case 16:
              this.introduceSample.exampleBranchName = '大阪北B';
              this.introduceSample.exampleFirst = '豊能支部';
              this.introduceSample.exampleLast = '幹事会';
              this.introduceSample.number1 = '2069';
              this.introduceSample.number2 = '2067';
              return _context.abrupt("break", 23);

            case 22:
              return _context.abrupt("break", 23);

            case 23:
              _context.next = 25;
              return this.$store.commit('company/setEnableTextAllSelect', false);

            case 25:
              _context.next = 27;
              return this.$store.dispatch('company/fetchAffiliation');

            case 27:
              _context.next = 29;
              return _apolloClient.apolloClient.query({
                query: _companyQuery.GET_INDUSTRIES
              });

            case 29:
              industries = _context.sent;
              this.industries = industries.data.industries; // / get User

              _context.next = 33;
              return _apolloClient.apolloClient.query({
                query: _companyQuery.GET_MEMBER_ALL
              });

            case 33:
              users = _context.sent;
              this.users = users.data.user; //

              _context.next = 37;
              return _apolloClient.apolloClient.query({
                query: _companyQuery.USER_AFFILIATION_LIST
              });

            case 37:
              user_aff = _context.sent;
              this.user_affiliations = user_aff.data.user_affiliation; //

              _context.next = 41;
              return _apolloClient.apolloClient.query({
                query: _companyQuery.GET_ROLE_DEFAULT
              });

            case 41:
              defaultRole = _context.sent;

              if (defaultRole.data) {
                if (defaultRole.data.role) {
                  if (defaultRole.data.role.length !== 0) {
                    this.defaultRole = defaultRole.data.role[0];
                  }
                }
              } //


              listData = [];
              listData = this.$store.getters.affiliations.map(function (item) {
                return createDataByElTree(item);
              });
              this.data = listData;

            case 46:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    handleRemoveExcelFile: function handleRemoveExcelFile(file, fileList) {
      this.log('handleRemoveExcelFile');
      this.excelFile = fileList;
    },
    handleAddExcelFile: function handleAddExcelFile(file, fileList) {
      this.log('handleAddExcelFile');

      if ((0, _checkExt.checkExtExcel)(file.name)) {
        this.excelFile = fileList;
      } else {
        this.excelFile = [];
        this.$refs.upload.clearFiles();
        this.$notify({
          title: 'エラー',
          message: '対応していないファイル形式です',
          type: 'error',
          duration: 0
        });
      }

      this.$refs.importForm.validate(function (valid) {});
    },
    submitUpload: function () {
      var _submitUpload = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var excelData, members, objects, line_no, objectAffiliation, setMembers, noticeOnlyOnce, users, index, isMember, listIdAffilation, _listIdOrganization, pathFromDepth, deleteAffiliationUser, _deleteAffiliationUser;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _deleteAffiliationUser = function _ref3() {
                  _deleteAffiliationUser = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee2(user_id, affiliationList) {
                    var _this3 = this;

                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _apolloClient.apolloClient.mutate({
                              mutation: _companyMutation.USER_AFFILIATION_DELETE,
                              variables: {
                                user_id: user_id,
                                affiliation_ids: affiliationList
                              }
                            }).catch(function (error) {
                              console.log(error);
                              _this3.centerDialogVisible = false;
                              return;
                            });

                          case 2:
                            return _context2.abrupt("return", _context2.sent);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                  return _deleteAffiliationUser.apply(this, arguments);
                };

                deleteAffiliationUser = function _ref2(_x, _x2) {
                  return _deleteAffiliationUser.apply(this, arguments);
                };

                _context3.next = 4;
                return this.$refs.importForm.validate(function (valid) {
                  if (!valid) {
                    return;
                  }

                  _this2.centerDialogVisible = true;
                });

              case 4:
                if (!(this.centerDialogVisible === false)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                this.log('submitUpload');
                this.uploadExcel = true;
                _context3.next = 10;
                return this.readExcelFileToJson(this.excelFile[0].raw);

              case 10:
                excelData = _context3.sent;

                if (!(excelData == null)) {
                  _context3.next = 16;
                  break;
                }

                this.centerDialogVisible = false;
                return _context3.abrupt("return");

              case 16:
                if (!(excelData.members === undefined)) {
                  _context3.next = 22;
                  break;
                }

                this.centerDialogVisible = false;
                this.$notify({
                  title: 'エラー',
                  message: '取込みファイルが正しくありません。',
                  type: 'error',
                  duration: 0
                });
                return _context3.abrupt("return");

              case 22:
                if (!(excelData.members.length === 0)) {
                  _context3.next = 26;
                  break;
                }

                this.centerDialogVisible = false;
                this.$notify({
                  title: 'エラー',
                  message: '取り込むデータがありません。',
                  type: 'error',
                  duration: 0
                });
                return _context3.abrupt("return");

              case 26:
                if (this.defaultRole) {
                  _context3.next = 30;
                  break;
                }

                this.centerDialogVisible = false;
                this.$notify({
                  title: 'エラー',
                  message: 'デフォルトの役割がありません。',
                  type: 'error',
                  duration: 0
                });
                return _context3.abrupt("return");

              case 30:
                members = excelData.members;
                objects = [];
                line_no = 2;
                this.found = 0;
                objectAffiliation = [];
                setMembers = (0, _toConsumableArray2.default)(new Set(members));
                this.is_error = false;
                noticeOnlyOnce = false;
                this.progress = 10;
                setMembers.forEach(function (member) {
                  var result = _this2.header_check(member);

                  if (result.status === false && noticeOnlyOnce === false) {
                    _this2.centerDialogVisible = false;
                    _this2.is_error = true;

                    _this2.$notify({
                      title: 'エラー',
                      message: result.message + ' (' + line_no + '行目)',
                      type: 'error',
                      duration: 0
                    });

                    noticeOnlyOnce = true;
                    return true;
                  }

                  var valueCheckId = _this2.affiliationIdError(member);

                  if (valueCheckId && noticeOnlyOnce === false) {
                    _this2.centerDialogVisible = false;
                    _this2.is_error = true;

                    _this2.$notify({
                      title: 'エラー',
                      message: '所属IDをご確認ください。' + ' (' + line_no + '行目)',
                      type: 'error',
                      duration: 0
                    });

                    noticeOnlyOnce = true;
                    return;
                  }

                  line_no++;

                  var is_hit = _this2.users.some(function (item) {
                    return item.employee_id === member.社員番号.toString().trim();
                  });

                  if (!is_hit) {
                    _this2.progress = 30;
                    _this2.found++; // check the value is not null & number

                    var employee = member.社員数;
                    var partNumber = member.パート_アルバイト数;

                    if (employee && (0, _validate.checkIsNumber)(employee) && employee !== 'null') {
                      employee = Number(member.社員数);
                    } else {
                      employee = null;
                    }

                    if (partNumber && (0, _validate.checkIsNumber)(partNumber) && partNumber !== 'null') {
                      partNumber = Number(member.パート_アルバイト数);
                    } else {
                      partNumber = null;
                    } // 同一IDではない場合追加


                    objects.push({
                      avatar: '',
                      last_name: member.社員名_姓.trim().replace(/\s+/g, ''),
                      // 社員名(姓)（必須）
                      last_name_furigana: member.社員名_ふりがな姓.trim().replace(/\s+/g, ''),
                      // 社員名(ふりがな姓)（必須）
                      name: member.社員名_名.trim().replace(/\s+/g, ''),
                      // 社員名（名）（必須）
                      name_furigana: member.社員名_ふりがな名.trim().replace(/\s+/g, ''),
                      // 社員名（ふりがな名）（必須）
                      position: member.役職名 ? member.役職名.trim() : null,
                      // 役職名
                      others: member.その他 ? member.その他.trim() : null,
                      role_id: _this2.defaultRole.id,
                      employee_id: member.社員番号.trim(),
                      mobile_phone: '',
                      // 社員携帯番号（未使用）
                      password: (0, _user.encrypt)(String(member.社員パスワード)),
                      // 社員パスワード（必須）
                      is_display: true,
                      is_active: true,
                      company: {
                        data: {
                          name: member.会社名,
                          // 会社名（必須）
                          name_furigana: member.会社名_ふりがな,
                          // 会社名（ふりがな）（必須）
                          industry: null,
                          phone_number: member.電話番号,
                          // 電話番号（必須）
                          mobile_phone: member.携帯電話,
                          // 携帯電話
                          fax: member.FAX,
                          // FAX
                          email: member.Email,
                          // Email
                          website: member.ホームページ,
                          // ホームページ
                          postcode: member.郵便番号,
                          // 郵便番号（必須）
                          address_1: member.会社所在地,
                          // 会社所在地（必須）
                          address_2: member.ビル名,
                          // ビル名
                          business_descriptions: member.事業内容,
                          // 事業内容
                          capital_stock: member.資本金,
                          // 資本金
                          employees: employee,
                          // 社員数
                          employees_part_time: partNumber,
                          // パート・アルバイト数
                          established: member.設立年月日 ? new Date(member.設立年月日).toLocaleString({
                            timeZone: 'Asia/Tokyo'
                          }) : null,
                          // 設立年月日
                          join_date: member.入会年月日 ? new Date(member.入会年月日).toLocaleString({
                            timeZone: 'Asia/Tokyo'
                          }) : null // 入会年月日（必須）

                        }
                      }
                    });
                  }
                });

                if (!this.is_error) {
                  _context3.next = 42;
                  break;
                }

                return _context3.abrupt("return");

              case 42:
                _context3.next = 44;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.ADD_IMPORT_MEMBER,
                  variables: {
                    objects: objects
                  }
                }).catch(function (error) {
                  console.log(error);
                  _this2.is_error = true;
                  _this2.centerDialogVisible = false;

                  _this2.$notify({
                    title: 'エラー',
                    message: '社員情報のインポートに失敗しました。',
                    type: 'error',
                    duration: 10000
                  });

                  _this2.log(error);

                  return;
                });

              case 44:
                this.progress = 50; // / 新しいアカウントが追加された時、data_userが更新されます

                _context3.next = 47;
                return _apolloClient.apolloClient.query({
                  query: _companyQuery.GET_MEMBER_ALL
                });

              case 47:
                users = _context3.sent;
                this.users = users.data.user;
                index = 0;

              case 50:
                if (!(index < setMembers.length)) {
                  _context3.next = 64;
                  break;
                }

                if (setMembers.length > 9) {
                  if (index === setMembers.length / 3) {
                    this.progress = 70;
                  }
                } // uidを取得する


                isMember = this.users.filter(function (item) {
                  return item.employee_id === setMembers[index].社員番号.trim();
                });

                if (!(isMember.length !== 0 && isMember)) {
                  _context3.next = 61;
                  break;
                }

                listIdAffilation = [];
                _listIdOrganization = (0, _toConsumableArray2.default)(new Set(members[index].所属_ID.toString().trim().split(','))).filter(function (item) {
                  return item.trim() !== '';
                });

                if (!(_listIdOrganization.length !== 0 && _listIdOrganization)) {
                  _context3.next = 61;
                  break;
                }

                pathFromDepth = (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, _listIdOrganization, false, true);
                pathFromDepth.forEach(function (item) {
                  listIdAffilation.push(item.id);
                  objectAffiliation.push({
                    affiliation_id: item.id,
                    user_id: isMember[0].uid
                  });
                });
                _context3.next = 61;
                return deleteAffiliationUser(isMember[0].uid, listIdAffilation);

              case 61:
                index++;
                _context3.next = 50;
                break;

              case 64:
                this.progress = 80;
                _context3.next = 67;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.USER_AFFILIATION_INSERT,
                  variables: {
                    objects: objectAffiliation
                  }
                }).catch(function (error) {
                  console.log(error);
                  _this2.is_error = true;
                  _this2.centerDialogVisible = false;

                  _this2.$notify({
                    title: 'エラー',
                    message: '社員情報のインポートに失敗しました。',
                    type: 'error',
                    duration: 10000
                  });

                  _this2.log(error);

                  return;
                });

              case 67:
                this.progress = 100;

                if (this.is_error === false) {
                  this.centerDialogVisible = false;
                  this.$notify({
                    title: '情報',
                    message: this.found + '件のインポートが完了しました。',
                    type: 'success',
                    duration: 10000
                  });
                }

              case 69:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function submitUpload() {
        return _submitUpload.apply(this, arguments);
      }

      return submitUpload;
    }(),
    header_check: function header_check(member) {
      if (typeof member.入会年月日 === 'undefined') {
        member.入会年月日 = null;
      } else {
        if ((0, _typeof2.default)(member.入会年月日) !== 'object') {
          member.入会年月日 = (0, _moment.default)(String(member.入会年月日)).format('YYYY-MM-DD');
        }
      }

      if (typeof member.所属_ID === 'undefined') {
        return {
          status: false,
          message: '「所属_ID」が未入力の箇所があります。'
        };
      }

      if (typeof member.会社名 === 'undefined') {
        member.会社名 = '';
      } else {
        member.会社名 = String(member.会社名);
      }

      if (typeof member.会社名_ふりがな === 'undefined') {
        member.会社名_ふりがな = null;
      } else {
        member.会社名_ふりがな = String(member.会社名_ふりがな.trim().replace(/\s+/g, ''));
      }

      if (typeof member.社員名_姓 === 'undefined') {
        return {
          status: false,
          message: '「社員名_姓」が未入力の箇所があります。'
        };
      }

      if (typeof member.社員名_名 === 'undefined') {
        return {
          status: false,
          message: '「社員名_名」が未入力の箇所があります。'
        };
      }

      if (typeof member.社員名_ふりがな姓 === 'undefined') {
        return {
          status: false,
          message: '「社員名_ふりがな姓」が未入力の箇所があります。'
        };
      }

      if (typeof member.社員名_ふりがな名 === 'undefined') {
        return {
          status: false,
          message: '「社員名_ふりがな名」が未入力の箇所があります。'
        };
      }

      if (typeof member.役職名 === 'undefined') {
        member.役職名 = null;
      }

      if (typeof member.郵便番号 === 'undefined') {
        member.郵便番号 = null;
      } else {
        if (member.郵便番号.toString().trim() !== '' && member.郵便番号.toString().trim() !== 'null') {
          var zipcode = this.zenkaku2hankaku(String(member.郵便番号).trim()).replace('−', '-').split('-');

          if (zipcode.length !== 2) {
            return {
              status: false,
              message: '「郵便番号」のフォーマット（区切りコード"-"の数）が正しくない箇所があります。'
            };
          }

          if (this.isNumber(zipcode[0]) === false || this.isNumber(zipcode[1]) === false) {
            return {
              status: false,
              message: '「郵便番号」のフォーマット（不正なコードの存在）が正しくない箇所があります。'
            };
          }

          if (zipcode[0].length !== 3) {
            return {
              status: false,
              message: '「郵便番号」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (zipcode[1].length !== 4) {
            return {
              status: false,
              message: '「郵便番号」のフォーマットが正しくない箇所があります。'
            };
          }
        }

        member.郵便番号 = this.zenkaku2hankaku(member.郵便番号.trim()).replace('−', '-').replace('−', '-').toString();
      }

      if (typeof member.会社所在地 === 'undefined') {
        member.会社所在地 = null;
      } else {
        member.会社所在地 = this.zenkaku2hankaku(member.会社所在地.trim()).toString();
      }

      if (typeof member.ビル名 === 'undefined') {
        member.ビル名 = null;
      } else {
        member.ビル名 = this.zenkaku2hankaku(member.ビル名.trim()).toString();
      }

      if (typeof member.電話番号 === 'undefined') {
        member.電話番号 = null;
      } else {
        if (member.電話番号.toString().trim() !== '' && member.電話番号.toString().trim() !== 'null') {
          var phone_number = this.zenkaku2hankaku(String(member.電話番号).trim()).replace('−', '-').replace('−', '-').split('-');

          if (phone_number.length !== 3) {
            return {
              status: false,
              message: '「電話番号」のフォーマット（区切りコード"-"の数）が正しくない箇所があります。'
            };
          }

          if (this.isNumber(phone_number[0]) === false || this.isNumber(phone_number[1]) === false || this.isNumber(phone_number[2]) === false) {
            return {
              status: false,
              message: '「電話番号」のフォーマット（不正なコードの存在）が正しくない箇所があります。'
            };
          }

          if (phone_number[0].length < 1 || phone_number[0].length > 5) {
            return {
              status: false,
              message: '「電話番号」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (phone_number[1].length < 1 || phone_number[1].length > 5) {
            return {
              status: false,
              message: '「電話番号」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (phone_number[2].length < 1 || phone_number[2].length > 5) {
            return {
              status: false,
              message: '「電話番号」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }
        }

        member.電話番号 = this.zenkaku2hankaku(member.電話番号.trim()).replace('−', '-').replace('−', '-').toString();
      }

      if (typeof member.携帯電話 === 'undefined') {
        member.携帯電話 = null;
      } else {
        if (member.携帯電話.trim() && member.携帯電話 !== 'null') {
          var mobile_phone = this.zenkaku2hankaku(String(member.携帯電話).trim()).replace('−', '-').replace('−', '-').split('-');

          if (mobile_phone.length !== 3) {
            return {
              status: false,
              message: '「携帯電話」のフォーマット（区切りコード"-"の数）が正しくない箇所があります。'
            };
          }

          if (this.isNumber(mobile_phone[0]) === false || this.isNumber(mobile_phone[1]) === false || this.isNumber(mobile_phone[2]) === false) {
            return {
              status: false,
              message: '「携帯電話」のフォーマット（不正なコードの存在）が正しくない箇所があります。'
            };
          }

          if (mobile_phone[0].length < 1 || mobile_phone[0].length > 5) {
            return {
              status: false,
              message: '「携帯電話」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (mobile_phone[1].length < 1 || mobile_phone[1].length > 5) {
            return {
              status: false,
              message: '「携帯電話」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (mobile_phone[2].length < 1 || mobile_phone[2].length > 5) {
            return {
              status: false,
              message: '「携帯電話」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }
        }

        member.携帯電話 = this.zenkaku2hankaku(member.携帯電話.trim()).replace('−', '-').replace('−', '-').toString();
      }

      if (typeof member.FAX === 'undefined') {
        member.FAX = null;
      } else {
        if (member.FAX !== 'null' && member.FAX) {
          var fax_number = this.zenkaku2hankaku(String(member.FAX).trim()).replace('−', '-').replace('−', '-').split('-');

          if (fax_number.length !== 3) {
            return {
              status: false,
              message: '「FAX」のフォーマット（区切りコード"-"の数）が正しくない箇所があります。'
            };
          }

          if (this.isNumber(fax_number[0]) === false || this.isNumber(fax_number[1]) === false || this.isNumber(fax_number[2]) === false) {
            return {
              status: false,
              message: '「FAX」のフォーマット（不正なコードの存在）が正しくない箇所があります。'
            };
          }

          if (fax_number[0].length < 1 || fax_number[0].length > 5) {
            return {
              status: false,
              message: '「FAX」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (fax_number[1].length < 1 || fax_number[1].length > 5) {
            return {
              status: false,
              message: '「FAX」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }

          if (fax_number[2].length < 1 || fax_number[2].length > 5) {
            return {
              status: false,
              message: '「FAX」のフォーマット（桁数）が正しくない箇所があります。'
            };
          }
        }

        member.FAX = this.zenkaku2hankaku(member.FAX.trim()).replace('−', '-').replace('−', '-').toString();
      }

      if (typeof member.Email === 'undefined') {
        member.Email = null;
      } else {
        member.Email = this.zenkaku2hankaku(member.Email.trim()).toString();
      }

      if (typeof member.ホームページ === 'undefined') {
        member.ホームページ = null;
      } else {
        member.ホームページ = this.zenkaku2hankaku(member.ホームページ.trim()).toString();
      }

      if (typeof member.業種コード === 'undefined') {
        member.業種コード = null;
      } else {
        var in_hit = this.industries.some(function (item) {
          return Number(item.code) === Number(member.業種コード);
        });

        if (in_hit) {
          member.業種コード = ('00' + Number(member.業種コード)).slice(-2);
        } else {
          member.業種コード = null;
        }
      }

      if (typeof member.事業内容 === 'undefined') {
        member.事業内容 = null;
      }

      if (typeof member.設立年月日 === 'undefined') {
        member.設立年月日 = null;
      } else if (member.設立年月日 === 'null' || member.設立年月日 === '') {
        member.設立年月日 = null;
      } else if ((0, _typeof2.default)(member.設立年月日) !== 'object') {
        if (member.設立年月日 !== '') {
          var dateyear = member.設立年月日.split('/');
          member.設立年月日 = dateyear.join('-');
        }
      }

      if (typeof member.資本金 === 'undefined') {
        member.資本金 = null;
      } else {
        member.資本金 = String(member.資本金);
      }

      if (typeof member.社員数 === 'undefined') {
        member.社員数 = null;
      }

      if (typeof member.パート_アルバイト数 === 'undefined') {
        member.パート_アルバイト数 = null;
      }

      if (typeof member.社員番号 === 'undefined') {
        return {
          status: false,
          message: '「社員番号」が未入力の箇所があります。'
        };
      }

      member.社員番号 = String(member.社員番号);

      if (this.isHanEisu(String(member.社員番号)) === false) {
        return {
          status: false,
          message: '「社員番号」は半角英数字で入力してください。'
        };
      }

      if (member.社員番号.length < 3) {
        return {
          status: false,
          message: '「社員番号」は3文字以上で入力してください。'
        };
      }

      if (typeof member.社員パスワード === 'undefined') {
        return {
          status: false,
          message: '「社員パスワード」が未入力の箇所があります。'
        };
      }

      member.社員パスワード = String(member.社員パスワード).trim();

      if (member.社員パスワード.toString().trim().length < 4) {
        return {
          status: false,
          message: '「社員パスワード」は４文字以上で入力してください。'
        };
      }

      if (member.社員パスワード.toString().trim().length > 8) {
        return {
          status: false,
          message: '「社員パスワード」は８文字以下で入力してください。'
        };
      }

      return {
        status: true,
        message: 'SUCCESS'
      };
    },
    zenkaku2hankaku: function zenkaku2hankaku(val) {
      var regex = /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g; // 入力値の全角を半角の文字に置換

      var value = val.replace(regex, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      }).replace(/[‐－―]/g, '-') // ハイフンなど
      .replace(/[～〜]/g, '~') // チルダ
      .replace(/u{3000}/g, ' '); // スペース

      return value;
    },
    isNumber: function isNumber(val) {
      var regex = new RegExp(/^[0-9]+$/);
      return regex.test(val);
    },
    findCompanyOverview: function findCompanyOverview(no, data) {
      var result = '';

      for (var i = 0; i < data.length; i++) {
        if (data[i].no === no) {
          result = data[i];
          return result;
        }
      }

      return null;
    },
    findRequirements: function findRequirements(no, data) {
      var result = [];

      for (var i = 0; i < data.length; i++) {
        if (data[i].no === no) {
          result.push(data[i]);
        }
      }

      return result;
    },
    findEmployeeMessage: function findEmployeeMessage(no, data) {
      var result = '';

      if (data === undefined) {
        result = {
          no: undefined,
          join_year1: undefined,
          // 入社年度1
          department1: undefined,
          // 所属1
          employee_name1: undefined,
          // 氏名1
          comment1: undefined,
          // メッセージ1
          join_year2: undefined,
          // 入社年度2
          department2: undefined,
          // 所属2
          employee_name2: undefined,
          // 氏名2
          comment2: undefined // メッセージ2

        };
        return result;
      }

      for (var i = 0; i < data.length; i++) {
        if (data[i].no === no) {
          result = data[i];
          return result;
        }
      }

      return null;
    },
    hankaku2Zenkaku: function hankaku2Zenkaku(str) {
      this.log('hankaku2Zenkaku = ' + str);
      var inStr = String(str);
      return inStr.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    },
    findTopNumber: function findTopNumber(str) {
      var strNum = this.hankaku2Zenkaku(str);
      this.log('strNum = ' + strNum);
      var result = '';

      if (strNum.length === 0) {
        result = '0';
      }

      for (var i = 0; i < strNum.length; i++) {
        if (strNum.charAt(i) >= '0' && strNum.charAt(i) <= '9') {
          result = result + strNum.charAt(i);
        } else {
          if (result.length > 0) {
            return Number(result);
          }
        }
      }

      return Number(result);
    },
    close: function close() {
      this.uploadExcel = false;
    },
    isHanEisu: function isHanEisu(str) {
      str = str === null ? '' : str;

      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    },
    log: function log(text) {},
    download: function download() {
      // Create a reference to the file we want to download
      var storageRef = _firebase.default.storage().ref().child((0, _validate.switchTitle)().importSample.toString()); // Get the download URL


      storageRef.getDownloadURL().then(function (url) {
        // Insert url into an <img> tag to "download"
        var link = document.createElement('a');
        link.href = url;
        link.download = url;
        link.click();
      }).catch(function (error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;

          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;

          case 'storage/canceled':
            // User canceled the upload
            break;

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
    },
    affiliationIdError: function affiliationIdError(member) {
      var inputMember = member.所属_ID;
      var checkNumberComma = (0, _validate.checkIsNumberAndComma)(inputMember);
      if (checkNumberComma === false) return true;
      var setMember = (0, _toConsumableArray2.default)(new Set(inputMember.toString().split(','))).filter(function (item) {
        return item.trim() !== '';
      });
      if (setMember.length === 0) return true;
      var affiliations = this.$store.getters.affiliations;
      var entireOrganizationId = [];
      var objectAffiliation = [];
      if (affiliations.length === 0) return true;

      function affliationSelect(aff) {
        if (setMember.filter(function (item) {
          return item.toString().trim() === aff.id.toString();
        }).length !== 0) objectAffiliation.push(aff);
        entireOrganizationId.push(aff.id.toString());
        if (aff.affiliations) return aff.affiliations.forEach(function (i) {
          return affliationSelect(i);
        });
      }

      if (affiliations) affiliations.forEach(function (item) {
        return affliationSelect(item);
      });
      var setAff = setMember.filter(function (member) {
        return (0, _toConsumableArray2.default)(new Set(entireOrganizationId)).some(function (entire) {
          return member.toString().trim() === entire.toString().trim();
        }) === false;
      });
      if (setAff.length !== 0) return true;
      var pathFromDepth = (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, objectAffiliation);
      if (pathFromDepth.filter(function (item) {
        return item.is_main;
      }).length === 0) return true;else return false;
    }
  }
};
exports.default = _default2;